import { useAppSelector } from '../redux/hook';

/**
 * Read the latest SSE event data from Redux.
 *
 * Usage:
 *   const data = useSse<PlayerJoinedEvent>('player-joined');
 *
 * Connection is managed separately via sseManager.connect(gameId).
 * This hook only reads — it never opens or closes the connection.
 */
export function useSse<T = any>(eventType: string): T | null {
  return useAppSelector((state) => state.sse.events[eventType] ?? null) as T | null;
}
